import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MentorMappingFilterModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-filter-data.model';
import { MentorMappingFilterMetaModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-filter-meta.model';
import { MentorMappingListingModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-grid-model';
import { MentorMappingModel } from 'common/models/page-models/mentor-mapping/mentor-mapping-model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { MentorMappingGridWidgetService } from 'common/widget/mentor/mentor-map-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class MentorMappingGridResolver extends GridResolver<MentorMappingModel, MentorMappingListingModel> {
    constructor(
        protected fs: MentorMappingGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties.recordPerPage;
        widget.searchableFeilds = metaModel.properties.searchableFields;
        transferData.filterData = new MentorMappingFilterModel();
        transferData.filterMeta = new MentorMappingFilterMetaModel().getMetaModel();
       // this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
}